import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function RouteLogger() {
  const location = useLocation();
  
  useEffect(() => {
    console.log('[ROUTE]', location.pathname + location.search);
  }, [location]);
  
  return null;
}
